var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoorIn = function SvgDoorIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55074 7.44792L10.5507 5.37542C11.2872 5.15708 12.0003 5.81667 12.0003 6.71584V8.00001H15.5003C16.3275 8.00001 17.0003 8.9246 17.0003 10.0604V10.6667V22.6667V24H19.5003C19.7766 24 20.0003 24.2983 20.0003 24.6667V26C20.0003 26.3683 19.7766 26.6667 19.5003 26.6667H15.0003V22.6667V10.6667H12.0003V26.6667H2.66699V24V8.78834C2.66699 8.15417 3.03121 7.60167 3.55074 7.44792ZM8.66699 16C8.66699 16.7363 9.11491 17.3333 9.66699 17.3333C10.2191 17.3333 10.667 16.7363 10.667 16C10.667 15.2638 10.2191 14.6667 9.66699 14.6667C9.11491 14.6667 8.66699 15.2638 8.66699 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9045 19.0682L24.8529 17.316L29.3333 17.316V14.6857L24.8529 14.6857L24.9045 12.9308C24.9045 12.1023 23.9089 11.6887 23.3258 12.2746L20.2717 15.3432C19.9103 15.7064 19.909 16.2939 20.2704 16.6571L23.3245 19.7258C23.9076 20.3116 24.9045 19.8967 24.9045 19.0682Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoorIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/door_in.96ac3880.svg";
export { ForwardRef as ReactComponent };